import React, { useEffect, useState } from 'react'

function usePagination({ data, itemShowPerPage }) {
    const [currentPage, setCurrentPage] = useState(0);


    const safeData = data || [];
    const itemLength = safeData.length; //use for //data.length;
    //const itemShowPerPage = itemShowPerPage;
    const totalPageNo = Math.ceil(itemLength / itemShowPerPage);

    const firstIndex = currentPage * itemShowPerPage;
    const lastIndex = firstIndex + itemShowPerPage;
    const currentItems = safeData.slice(firstIndex, lastIndex);

    // 🔥 Reset page when data changes
    useEffect(() => {
        setCurrentPage(0);
    }, [data]);

    const handlePrev = () => {
        if (currentPage > 0) {
            setCurrentPage(prev => prev - 1);
        }
    }

    const handleNext = () => {
        if (currentPage < totalPageNo - 1) {
            setCurrentPage(prev => prev + 1);
        }
    }


    // =========================
    // OPTIONAL: LIMIT PAGES (like Google)
    // =========================
    const getVisiblePages = () => {
        const start = Math.max(0, currentPage - 2);
        const end = Math.min(totalPageNo, currentPage + 3);

        return [...Array(totalPageNo).keys()].slice(start, end);
    };
    return { currentItems, getVisiblePages, currentPage, setCurrentPage, handlePrev, handleNext, totalPageNo }
}

export default usePagination